import { render, staticRenderFns } from "./head_img2.vue?vue&type=template&id=42bdc61b&scoped=true"
import script from "./head_img2.vue?vue&type=script&lang=js"
export * from "./head_img2.vue?vue&type=script&lang=js"
import style0 from "./head_img2.vue?vue&type=style&index=0&id=42bdc61b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdc61b",
  null
  
)

export default component.exports